import { Grid, Typography } from '@mui/material';
import BlockIcon from '@mui/icons-material/Block';
import { useIntl } from 'react-intl';
import ErrorIcon from '@mui/icons-material/Error';
import CloudOffIcon from '@mui/icons-material/CloudOff';

const ErrorView = ({ error }: { error: Error }) => {
    const intl = useIntl();
    const icon = () => {
        switch (error.name) {
            case 'ForbiddenError':
                return <BlockIcon fontSize="inherit" color="error" />;
            case 'ConnectionError':
                return <CloudOffIcon fontSize="inherit" color="error" />;

            default:
                return <ErrorIcon fontSize="inherit" color="error" />;
        }
    };

    return (
        <Grid container xs={12} p={5} justifyContent="center" flexDirection="column" alignItems="center" gap={3} fontSize="150px">
            <Typography variant="h3">{intl.formatMessage({ id: error.message })}</Typography>
            {icon()}
        </Grid>
    );
};

export default ErrorView;
